import React, { Component } from "react";
import cx from "classnames";
import {
  Theme,
  createStyles,
  WithStyles,
  withStyles,
  Typography,
  Grid,
  Button,
  Tabs,
  Tab,
} from "@material-ui/core";

import {
  MyPATExpansionPanel,
  MyPATMathField,
  MyPATTextField,
} from "../../../common";
import ContentFormData from "../../types/ContentFormData";
import ContentFormDataError from "../../types/ContentFormDataError";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { questionActions } from "../../reducers/questionCreateReducer";
import { SolutionStep, StepWiseSolution } from "../../types/ContentData";
import { getUserType, onlyAllowNumbers } from "../../../../utils";
import _ from "lodash";
import AddFeedback from "../../../content-request/components/AddFeedback";
import classNames from "classnames";
import AddIcon from '@material-ui/icons/Add';
import { setPopUpData } from '../../../common/actions/focusedSectionAction';
import POPUP_DATA from '../../../../constants/popUpData';
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import { SECTIONS } from "../../helper/contentValidation";
import AddFeedbackPopup from "./AddFeedbackPopup";
import { USER_TYPE } from '../../../../constants/comman';

const styles = (theme: Theme) =>
  createStyles({
    mt15:{
      marginTop: 15
    },
    feedbackContainer: {
      position: "relative",
      "& .feedbackBlock": {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
    },
    blueColor: {
      color: "#1D7DEA",
    },
    answerTable: {
      width: "auto",
      "& tbody": {
        "& tr": {
          height: "auto",
          "& td": {
            padding: `${theme.spacing.unit / 2}px 0`,
            border: 0,
            textAlign: "center",
            minWidth: theme.spacing.unit * 10,
            "&:last-child": {
              paddingRight: 0,
            },
          },
          "&:first-child": {
            "& td": {
              borderRight: `1px solid ${theme.palette.grey[300]}`,
              "&:last-child": {
                borderRight: 0,
              },
            },
          },
        },
      },
    },
    tabs: {
      fontSize: 16,
      lineHeight: "19px",
      color: "#333",
      cursor: "pointer",
      // minWidth: 150,
      padding: '0 15px 16px',
      // paddingRight: 0,
      // paddingLeft: 0,
      marginRight: 20,
      minWidth: 'initial',
      '&>span':{
        '& span:nth-of-type(1)':{
          padding: '6px 0',
      },
    },
    },
    activeTab: {
      fontWeight: 600,
      color: "#1d7dea!important",
      position: "relative",
      fontSize: 16,
      opacity: 1, 
      "&::before": {
        content: '""',
        width: "86px",
        height: "4px",
        borderRadius: 10,
        backgroundColor: "#1d7dea",
        position: "absolute",
        bottom: "12px",
      },
    },
    overflowAuto: {
      overflow: "auto",
      width: "100%",
      padding: "0",
      margin: "4px",
    },
    answerBox: {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing.unit,
      "& textarea": {
        border: 0,
        padding: 0,
      },
      "& h6": {
        color: theme.palette.grey[400],
      },
      "& .suggested-box": {
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing.unit,
        width: "100%",
        marginBottom: theme.spacing.unit,
        "&:last-child": {
          marginBottom: 0,
        },
      },
    },

    borderBox: {
      background: "#FFFFFF",
      border: "1px solid #E1E1E1",
      boxSizing: "border-box",
      padding: theme.spacing.unit,
      borderRadius: 5,
      overflow: "auto",
    },
    overFlow: {
      overflow: "auto",
    },
    checkboxChecked: {
      color: "#59CA1C !important",
    },

    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },

    mb1x: {
      marginBottom: theme.spacing.unit,
    },

    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },
    marginLeftAuto: {
      marginLeft: "auto",
    },

    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    // Solution
    buttonOutline: {
      fontSize: "14px!important",
      fontWeight: 600,
      minWidth: '138px',
      "&>span": {
        fontSize: "14px!important",
        fontWeight: 600,
      },
    },
    buttonTxt: {
      fontSize: 14,
      fontWeight: 600,
      color: "#F44771",
    },
    TabPanelOrange: {
      padding: "5px 20px",
      borderRadius: "2px 2px 0px 0px",
      backgroundColor: "#F5B14B",
      color: "#fff",
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "20px",
      marginLeft: 16,
    },
    TabPanelGreen: {
      padding: "5px 20px",
      borderRadius: "2px 2px 0px 0px",
      backgroundColor: "#78D2A7",
      color: "#fff",
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "20px",
      marginLeft: 16,
    },
    textCenter: {
      textAlign: "center",
    },
    textLeft: {
      textAlign: "left",
      cursor: 'pointer'
    },
    textright: {
      textAlign: "right",
    },
    stepsContainer: {
      marginTop: 24,
      "&>:first-child": {
        display: "block",
        "&>:nth-child(2)": {
          "&>:first-child": {
            "& input": {
              display: "block",
              width: "100%",
              height: "94px",
              fontSize: 14,
              color: "#666",
              lineHeight: 19,
            },
          },
        },
      },
    },
    labelHeading: {
      textAlign: "left",
      fontSize: 12,
      color: "#333",
      lineHeight: "22px",
      "& span": {
        color: "#666",
      },
    },
    mt_20: {
      marginTop: "-20px",
    },
    pr0: {
      paddingRight: "0!important",
    },
    mt24: {
      marginTop: "24px",
    },
    mtb30: {
      margin: "30px 0",
    },
    stepNo: {
      margin: "5px 5px 5px 20px",
    },
    addStep: {
      margin: "10px 40px",
    },
    weightagePanel: {
      position: "relative",
      marginTop: "-20px",
      "&>:first-child": {
        marginLeft: "20px",
      },
      "&>:nth-child(2)": {
        marginLeft: 20,
        "&>:first-child": {
          "& input": {
            width: 80,
          },
        },
      },
      "&>:nth-child(3)": {
        fontSize: 14,
        lineHeight: "24px",
        fontWeight: 600,
        color: "#333",
        position: "absolute",
        top: 32,
        right: 10,
      },
    },
    deleteStepBtn: {
      cursor: "pointer",
    },
    seperator: {
      textAlign: "center",
      borderBottom: "1px solid #E4E4E4",
      position: "relative",
      "&>:first-child": {
        "&:first-child": {
          "&>:first-child": {
            background: "#fff",
            padding: "5px",
            fontSize: 14,
            color: "#989898",
            backgroundColor: "#E4E4E4",
            width: 31,
            height: 31,
            borderRadius: "50%",
            fontStyle: "italic",
            position: "absolute",
            bottom: "-16px",
          },
        },
      },
    },

    feedbackHighlight: {
      cursor: "pointer",
      "&:hover": {
        color: "#1d7dea",
      },
    },
    allStepsContainer: {
      border: "1px solid #DFDFDF",
      borderRadius: "4px",
      marginTop: "2px",
    },
    solutionContainer: {
      marginTop: "24px",
    },
    displayFlex:{
      display: 'flex',
      alignItems: 'center',
    },
    optionalText: {
      fontSize: '20px',
      color: '#999999',
    },
  });

interface QuestionSolutionProps extends WithStyles<typeof styles> {
  questionIndex?: number;
  subType: string;
  error: boolean;
  errorText: string;
  stepWiseSolution: StepWiseSolution[][];
  showWeightage?: boolean;
  activeSolution?: number;
  addStepWiseSolution: (data: { questionIndex?: number }) => void;
  deleteStepWiseSolution: (data: {
    solutionNo: number;
    questionIndex?: number;
  }) => void;
  activeStepWiseSolution: number[];
  setActiveStepSolution: (data: {
    questionIndex?: number;
    tabNo?: number;
  }) => void;
  addStepOfStepWiseSolution: (data: {
    solutionNo: number;
    questionIndex?: number;
  }) => void;
  editStepOfStepWiseSolution: (payload: {
    solutionNo: number;
    stepNo: number;
    questionIndex?: number;
    updates: Partial<SolutionStep>;
  }) => void;
  deleteStepOfStepWiseSolution: (payload: {
    solutionNo: number;
    stepNo: number;
    questionIndex?: number;
  }) => void;
  editFormulaUsedForSolution: (payload: {
    value: string;
    questionIndex?: number;
  }) => void;
  onChange: (stepWiseSolution: StepWiseSolution[]) => void;
  tag: string;
  openFeedback: boolean;
  addFeedback: Function;
  replyFeedback: Function;
  closeFeedback: Function;
  resolveFeedback: Function;
  clickedfeedbackData: any;
  addNewFeedback: Function;
  selectedIndex: number;
  questionId?: string;
  sectionId?: string;
  authorType?: string;
  isDisable: boolean;
  setPopUpData: Function;
  activeValidationFeedbackSection: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
}

interface QuestionSolutionState {
  mathEditor: any;

}

class QuestionSolution extends Component<
  QuestionSolutionProps,
  QuestionSolutionState
> {
  handleOnChange: any = () => {};
  constructor(props: QuestionSolutionProps) {
    super(props);
    this.state = {
      mathEditor: null,
  
    };
    this.setMathInstance = this.setMathInstance.bind(this);
    this.checkForFeedback = this.checkForFeedback.bind(this);
    this.handleOnChange = _.debounce(props.onChange, 500);
  }

  shouldComponentUpdate(prevProps: QuestionSolutionProps) {
    const allowUpdate =
      prevProps.tag !== this.props.tag || prevProps.isDisable !== this.props.isDisable ||
      prevProps.openFeedback !== this.props.openFeedback ||
      prevProps.clickedfeedbackData !== this.props.clickedfeedbackData ||
      prevProps.questionId !== this.props.questionId ||
      prevProps.selectedIndex !== this.props.selectedIndex ||
      prevProps.stepWiseSolution[prevProps.questionIndex || 0] !==
        this.props.stepWiseSolution[this.props.questionIndex || 0] ||
      prevProps.error !== this.props.error ||
      prevProps.errorText !== this.props.errorText ||
      prevProps.activeStepWiseSolution[prevProps.questionIndex || 0] !==
        this.props.activeStepWiseSolution[this.props.questionIndex || 0] ||
      prevProps.activeValidationFeedbackSection !== this.props.activeValidationFeedbackSection;
    if (allowUpdate) {
      return true;
    }
    return false;
  }

  checkForFeedback() {
    let { clickedfeedbackData, questionId } = this.props;
    if(this.props.selectedIndex !== undefined) {
      return (( _.isEmpty(clickedfeedbackData) && this.props.openFeedback && this.props.tag === "solution" && this.props.selectedIndex === this.props.questionIndex) || (!_.isEmpty(clickedfeedbackData) && this.props.openFeedback && clickedfeedbackData.tag === "solution" && questionId === clickedfeedbackData.contentId))
    } else {
      return this.props.openFeedback && this.props.tag === "solution";
    }
  }

  componentDidUpdate() {
    const { stepWiseSolution, questionIndex = 0 } = this.props;
    this.handleOnChange(stepWiseSolution[questionIndex]);
  }

  setMathInstance = (mathEditor: any) => {
    this.setState({ mathEditor });
  };

  handleAddingSolution = (evt: any) => {
    evt.stopPropagation();
    const questionIndex = this.props.questionIndex || 0;
    this.props.addStepWiseSolution({ questionIndex });

  };
  handleTabClick = (tabNo: number) => {
    const questionIndex = this.props.questionIndex || 0;
    this.props.setActiveStepSolution({ questionIndex, tabNo });
  };

  handleWeightageChange = (solutionNo: number, stepNo: number) => (e: any) => {
    const value = e.target.value;
    if (!value || (value && parseInt(value) <= 100)) {
      const { questionIndex, } = this.props;
      this.props.editStepOfStepWiseSolution({
        solutionNo,
        stepNo,
        questionIndex,
        updates: { weightage: e.target.value },
      });
    }
  };
  renderActiveSolutionTab = () => {
    const {
      classes,
      editStepOfStepWiseSolution,
      editFormulaUsedForSolution,
      stepWiseSolution: stepWiseSolutionOfAllQuestions,
      questionIndex = 0,
      showWeightage,
      deleteStepWiseSolution,
      deleteStepOfStepWiseSolution,
      addStepOfStepWiseSolution,
      activeStepWiseSolution,
    } = this.props;
    const activeSolutionNo = activeStepWiseSolution[questionIndex];

    const stepWiseSolution =
      stepWiseSolutionOfAllQuestions[questionIndex] || [];
    if (stepWiseSolution.length === 0) {
      return null;
    }

    const solution = stepWiseSolution[activeSolutionNo];
    if (!solution) {
      return null;
    }
    return (
      <Grid>
        <Grid container justify="space-between" alignItems="center">
          <Grid item xs={12}>
            <span className={classes.TabPanelOrange}>Formula Used</span>
            <MyPATMathField
              variant="textarea"
              key={`formulaUser-${activeSolutionNo + 1}`}
              editorProps={{
                externalToolbarId: "box",
                handleChange: (e: any) =>
                  editFormulaUsedForSolution({
                    value: e.target.value,
                    questionIndex,
                  }),
                setInstance: this.setMathInstance,
                editorId: `formulaUser-${activeSolutionNo + 1}`,
                value: solution.formulaUsed,
    						placeholder: 'Solution Text, or Paste Image'
              }}
            />
          </Grid>
        </Grid>
        {/* Steps */}
        <Grid container className={classes.solutionContainer}>
          <Grid item xs={12}>
            <span className={classes.TabPanelGreen}>
              Solution {activeSolutionNo + 1}
            </span>
          </Grid>
          <Grid item xs={12} className={classes.allStepsContainer}>
            {solution.solutionSteps.map((solutionStep, j) => {
              const isFirstStep = j === 0;
              return (
                <>
                  <Grid
                    key={activeSolutionNo + j}
                    container
                    justify="flex-start"
                    alignItems="flex-start"
                    className={classes.stepsContainer}
                    spacing={8}
                  >
                    <Grid item className={classes.stepNo} xs="auto">
                      {j + 1}.{" "}
                    </Grid>
                    <Grid item xs>
                      <MyPATMathField
                        variant="textarea"
                        editorProps={{
                          externalToolbarId: "box",
                          name: `solution-${activeSolutionNo + 1}-step-${j}`,
                          handleChange: (e: any) =>
                            editStepOfStepWiseSolution({
                              solutionNo: activeSolutionNo,
                              stepNo: j,
                              questionIndex,
                              updates: { solution: e.target.value },
                            }),
                          setInstance: this.setMathInstance,
                          editorId: `solution-${activeSolutionNo +
                            1}-step-${j}`,
                          value: solutionStep.solution,
                          placeholder: `Add Text, or Paste Image in Step ${j+1}`
                        }}
                      />
                    </Grid>
                    {showWeightage && (
                      <Grid item xs={2} className={classes.weightagePanel}>
                        <label className={classes.labelHeading}>
                          Weightage <span>(Marks)</span>
                        </label>
                        <MyPATTextField
                          type="number"
                          value={solutionStep.weightage}
                          onKeyPress={onlyAllowNumbers}
                          onChange={this.handleWeightageChange(
                            activeSolutionNo,
                            j
                          )}
                          inputProps={{ min: 0, max: 100 }}
                        />
                        <span>%</span>
                      </Grid>
                    )}
                    <Grid item xs={1} className={[classes.textLeft, classes.mt15].join(' ')}>
                      {!isFirstStep && (
                        <img
                          src="/assets/svg/myLibrary/delete-outline.svg"
                          alt="delete step"
                          onClick={() =>
                            deleteStepOfStepWiseSolution({
                              solutionNo: activeSolutionNo,
                              stepNo: j,
                              questionIndex,
                            })
                          }
                        />
                      )}
                    </Grid>
                  </Grid>
                </>
              );
            })}
            <Grid item xs={12} className={classes.addStep}>
              <Button
                variant="text"
                color="primary"
                className={classes.buttonOutline}
                onClick={() =>
                  addStepOfStepWiseSolution({
                    questionIndex,
                    solutionNo: activeSolutionNo,
                  })
                }
              >
                + Add Step
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justify="flex-start" className={classes.mt24} />
      </Grid>
    );
  };
  showPopup = () => {
    this.props.setPopUpData(POPUP_DATA.ANSWER);
  }
  render() {
    const {
      classes,
      subType,
      error,
      errorText,
      stepWiseSolution: stepWiseSolutionOfAllQuestions,
      questionIndex = 0,
      activeStepWiseSolution,
      deleteStepWiseSolution,
      sectionId = "solutions",
      isDisable,
      activeValidationFeedbackSection,
      activeValidationFeedbackData,
      handleAddCommentInFeedback,
      createNewValidationFeedback,
    } = this.props;
    const stepWiseSolution =
      stepWiseSolutionOfAllQuestions[questionIndex] || [];
    const activeSolutionNo = activeStepWiseSolution[questionIndex];
    const isFirstSolution = activeSolutionNo === 0;
    const studentUser = getUserType(USER_TYPE.STUDENT); 
    return (
      <>
        <MyPATExpansionPanel
          isDisable={isDisable}
          hasExpandIcon
          defaultExpanded={true}
          sectionId={sectionId} // used for scrolling to this section
          variant="white"
          customCollapseTitle={
            <>
              <Grid
                container
                justify="space-between"
                alignItems="center"
                className={classes.pr0}
              >
                <Grid item>
                  <Typography
                    variant="h6"
                    className={classes.cardHeading}
                    onClick={(event) =>
                      {
                        event.stopPropagation();
                        this.props.addFeedback("solution", questionIndex)}
                    }
                  >
                    <span
                      id={this.checkForFeedback() ? "feedbackScroll" : ""}
                      className={`${classes.feedbackContainer} ${
                        this.checkForFeedback() ? classes.blueColor : ""
                      } ${
                        this.props.openFeedback ? classes.feedbackHighlight : ""
                      }`}
                    >
                      Solutions
                      {studentUser ? <span className={classes.optionalText}> (Optional) </span> : <span className={classes.requiredHeading}>*</span>}
                      {this.checkForFeedback() && (
                        <Grid className="feedbackBlock">
                          <AddFeedback
                            replyFeedback={this.props.replyFeedback}
                            closeFeedback={this.props.closeFeedback}
                            resolveFeedback={this.props.resolveFeedback}
                            clickedfeedbackData={this.props.clickedfeedbackData}
                            addNewFeedback={this.props.addNewFeedback}
                            author={this.props.authorType}
                          />
                        </Grid>
                      )}
                      {
                        activeValidationFeedbackSection === SECTIONS.SOLUTION && (
                          <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                        )
                      }
                    </span>
                    <CustomInfoIcon
                      infoDialogContentType="Goal Management"
                      isInfoIcon={true}
                      isRightArrow={false}
                      isCenterArrow={true}
                      knowMoreAbout={false}
                      dialogTitle="Solutions"
                      imageURL="/assets/svg/infoIcon/solutions.svg"
                      dialogPara="The Solution added here will be accessible to the students on their platform. Provide the elaborative solution explaining the step by step details and multiple approaches (if any)"
                      details="Click to know more"
                      toolTipDirection="top" />
                  </Typography>
                </Grid>
              </Grid>
            </>
          }
          error={error}
          errorText={errorText}
          showErrorOnTouch
        >
          <Grid>
            <Grid
              container
              spacing={8}
              justify="flex-start"
              className={`${classes.overFlow} ${classes.mb2x}`}
              alignItems="center"
            >
              <Grid item xs={9}>
                <Grid className={classes.displayFlex}>
                <Tabs
                  value={false}
                  indicatorColor="primary"
                  classes={{ scroller: classes.overflowAuto }}
                >
                  {stepWiseSolution.map((solution, i) => {
                    const isActive = i === activeSolutionNo;
                    return (
                      <Tab
                        label={`Solution ${i + 1}`}
                        key={i}
                        className={cx(
                          classes.tabs,
                          isActive && classes.activeTab
                        )}
                        onClick={() => this.handleTabClick(i)}
                      />
                    );
                  })}
                </Tabs>
                {/* <Grid> */}
                <Button
                  variant="text"
                  color="primary"
                  className={classes.buttonOutline}
                  onClick={this.handleAddingSolution}
                >
                  <AddIcon /> Add Solution
                </Button>
                </Grid>
              {/* </Grid> */}
              </Grid>

              {!isFirstSolution && (
                <Grid item xs={3} className={classes.marginLeftAuto}>
                  <Button
                    onClick={() =>
                      deleteStepWiseSolution({
                        questionIndex,
                        solutionNo: activeSolutionNo,
                      })
                    }
                  >
                    <span>Solution {activeSolutionNo + 1} </span>&nbsp;
                    <img
                      src="/assets/svg/myLibrary/delete-outline.svg"
                      alt="delete step"
                      className={classes.deleteStepBtn}
                    />
                  </Button>
                </Grid>
              )}
            </Grid>
            {this.renderActiveSolutionTab()}
          </Grid>
        </MyPATExpansionPanel>
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    stepWiseSolution: state.questionCreate.stepWiseSolution,
    activeStepWiseSolution: state.questionCreate.activeStepWiseSolution,
  };
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      addStepWiseSolution: questionActions.addStepWiseSolution,
      setActiveStepSolution: questionActions.setActiveStepSolution,
      deleteStepWiseSolution: questionActions.deleteStepWiseSolution,
      editFormulaUsedForSolution: questionActions.editFormulaUsedForSolution,
      addStepOfStepWiseSolution: questionActions.addStepOfStepWiseSolution,
      editStepOfStepWiseSolution: questionActions.editStepOfStepWiseSolution,
      deleteStepOfStepWiseSolution:
        questionActions.deleteStepOfStepWiseSolution,
      setPopUpData
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(QuestionSolution));
